import {Component, Input, ContentChildren, QueryList, AfterContentInit} from '@angular/core';
import {WizardTab} from "./wizard.tab";
import {WizardContent} from "./wizard.content";
import {WizardPrev} from "./wizard.prev";
import {WizardNext} from "./wizard.next";

//see wizard.api.html
//web component for multispeps forms
@Component({
    selector: 'wizard',
    template: require('./wizard.template.html')
})
export class Wizard implements AfterContentInit {

    //todo andrey implement vertical tabs alignment
    @Input('tabs-alignment')
    public tabsAlignment: string;

    //list of child tabs components
    @ContentChildren(WizardTab)
    tabs: QueryList<WizardTab>;

    //list of child contents of tabs components
    @ContentChildren(WizardContent)
    contents: QueryList<WizardContent>;

    //list of prev buttons components
    @ContentChildren(WizardPrev)
    prevs: QueryList<WizardPrev>;

    //list of next buttons components
    @ContentChildren(WizardNext)
    nexts: QueryList<WizardNext>;

    private currentTab: WizardTab;

    navigationBarHidden: boolean = false;

    hideNavigationBar() {
        this.navigationBarHidden = true;
    }

    ngAfterContentInit() {
        this.setupTabs();
        this.setupPrevButtons();
        this.setupNextButtons();
    }

    /**
     * Setup tabs to communicate with wizard
     */
    private setupTabs() {
        let prevTab: WizardTab;
        this.tabs.forEach((tab: WizardTab) => {
            //setup queue
            if (prevTab) {
                prevTab.setNextTab(tab);
                tab.setPrevTab(prevTab);
            }
            //sharing parent object with child tabs
            tab.setupParent(this);
            prevTab = tab;
            //if tab has default attribute, then select it
            if (tab.isDefault) {

                setTimeout(()=> {
                    this.selectTab(tab)
                });
            }
        });
    }

    /**
     * Setup prev buttons to communicate with wizard
     */
    private setupPrevButtons() {
        this.prevs.forEach((prev: WizardPrev) => {
            prev.setupPrevLoader(()=> {
                this.selectPrevTab();
            });
        });
    }

    /**
     * Setup next buttons to communicate with wizard
     */
    private setupNextButtons() {
        this.nexts.forEach((next: WizardNext) => {
            next.setupNextLoader(()=> {
                this.selectNextTab();
            });
        });
    }

    /**
     * Handle tab click
     * @param selectedTab - clicked tab
     */
    handleTabSelected(selectedTab: WizardTab) {
        this.selectTab(selectedTab);
    }

    /**
     * Select tab
     * @param selectedTab - tab to activate
     */
    selectTab(selectedTab: WizardTab) {
        this.currentTab = selectedTab;
        this.currentTab.isDone = true;
        this.tabs.forEach((tab: WizardTab) => {
            let state = tab === selectedTab;
            tab.setTabState(state);
        });
        this.contents.forEach((content: WizardContent) => {
            content.setContentState(content.tabId === selectedTab.tabId);
        });
    }

    /**
     * Next tab action
     */
    selectNextTab() {
        if (this.currentTab && this.currentTab.next) {
            this.handleTabSelected(this.currentTab.next);
        }
    }

    /**
     * Prev tab action
     */
    selectPrevTab() {
        if (this.currentTab && this.currentTab.prev) {
            this.handleTabSelected(this.currentTab.prev);
        }
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.component.ts